import { knowledgeBaseConstants } from '@constants/knowledge-base';

const initialState = {
    data: [],
    loading: true,
    totalCount: 0,
    pages: 1,
    query: null,
};

export function knowledgeBase(state = initialState, action) {
    switch (action.type) {
        case knowledgeBaseConstants.KNOWLEDGE_BASE_REQUEST:
            return { ...state, loading: true, query: action.query };
        case knowledgeBaseConstants.KNOWLEDGE_BASE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data.items,
                totalCount: action.data.totalCount,
                pages: action.data.pages,
            };
        case knowledgeBaseConstants.KNOWLEDGE_BASE_FAILURE:
            return { ...state, loading: false };
        default:
            return state;
    }
}
